<p-confirmDialog key="notify" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<!--Table-->
<div class="table-main-body">
	<p-table
		#mydt
		[value]="lstSchool"
		[loading]="loading"
		[paginator]="true"
		[(rows)]="pagerows"
		[(first)]="pagefirst"
		[showCurrentPageReport]="true"
		[resizableColumns]="false"
		sortMode="multiple"
		styleClass="p-datatable-striped"
		selectionMode="multiple"
		[(selection)]="SelectedSchools"
		dataKey="SchoolID"
		(onFilter)="onHandleFilter($event)"
		(onSort)="onHandleSort($event)"
		(onRowSelect)="onRowSelect($event)"
		(onRowUnselect)="onRowUnselect($event)"
		currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
		[rowsPerPageOptions]="[5, 10, 25, 50]"
	>
		<!--Headers-->
		<ng-template pTemplate="header">
			<!--Filter or Select from Dropdown-->
			<tr>
				<th></th>

				<!--INSERT CUSTOM FILTERS HERE-->

				<!--NotifyEnabled-->
				<th>
					<p-columnFilter field="NotifyEnabled" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterNotifyEnabled
								[ngModel]="value"
								[options]="lstNotifyEnabled"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>

				<!--SchoolID-->
				<th>
					<p-columnFilter type="text" field="SchoolID" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--SchoolNumber-->
				<th>
					<p-columnFilter type="text" field="SchoolNumber" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--SchoolName-->
				<th>
					<p-columnFilter type="text" field="SchoolName" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--c_date-->
				<th>
					<!-- <p-columnFilter type="text" field="c_date" matchMode="contains" [showMenu]="true"></p-columnFilter> -->
				</th>

				<!--ActiveDesc-->
				<th>
					<p-columnFilter field="ActiveDesc" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterActiveDesc
								[ngModel]="value"
								[options]="lstActiveDesc"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>
			</tr>

			<!--Column Names-->
			<tr style="height: 4rem">
				<th></th>
				<!--INSERT CUSTOM COLUMNS HERE-->
				<th pSortableColumn="NotifyEnabled">Notify Enabled<p-sortIcon field="NotifyEnabled"></p-sortIcon></th>
				<th pSortableColumn="SchoolID">School ID<p-sortIcon field="SchoolID"></p-sortIcon></th>
				<th pSortableColumn="SchoolNumber">School Number<p-sortIcon field="SchoolNumber"></p-sortIcon></th>
				<th pSortableColumn="SchoolName">School Name<p-sortIcon field="SchoolName"></p-sortIcon></th>
				<th pSortableColumn="c_date">Last Updated<p-sortIcon field="c_date"></p-sortIcon></th>
				<th pSortableColumn="ActiveDesc">Active<p-sortIcon field="ActiveDesc"></p-sortIcon></th>
			</tr>
		</ng-template>

		<!--Data-->
		<ng-template pTemplate="body" let-School>
			<tr [pSelectableRow]="School">
				<td>
					<p-tableCheckbox [pSelectableRow]="School" [value]="School"></p-tableCheckbox>
				</td>
				<td style="font-weight: bold" [style.color]="School['NotifyEnabled'] == 'Yes' ? 'limegreen' : 'Red'">
					{{ School["NotifyEnabled"] }}
				</td>
				<td *ngFor="let col of cols" style="font-weight: bold">
					{{ School[col.field] }}
				</td>
				<td style="font-weight: bold" [style.color]="School['ActiveDesc'] == 'Inactive' ? 'Red' : 'Black'">
					{{ School["ActiveDesc"] }}
				</td>
			</tr>
		</ng-template>
	</p-table>
</div>

<div class="Buttons">
	<button [disabled]="loading == true || processing == true" class="btn btn-primary" (click)="onRefresh()">Refresh</button>
	<button [disabled]="loading == true || processing == true" class="btn btn-primary" (click)="onEnableNotify()">Enable CAASS Notify</button>
	<button [disabled]="loading == true || processing == true" class="btn btn-primary" (click)="onDisableNotify()">Disable CAASS Notify</button>
	<button [disabled]="loading == true || processing == true" class="btn btn-primary" (click)="onClear()">Clear Selection</button>
</div>

<!--Error Message-->
<div class="TopMargin">
	<div name="errorMessage" *ngIf="errorMessage" class="alert alert-danger">
		{{ errorMessage }}
	</div>
</div>
